import { RadioGroupOption } from "Shared/components/radio-group";
import { BankResource } from "Shared/util/types";

const NordeaBic: string = "NDEASESS";

export const radioGroupOptionMapper = (
    bank: BankResource | undefined,
    t: any,
): RadioGroupOption => ({
    label:
        bank?.bic === NordeaBic
            ? `${bank.name} ${t.nordea_restriction}`
            : bank?.name || "",
    value: bank?.bic || "",
});
